// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PlayButton_wrapper__j2W01","japan":"PlayButton_japan__OwbKv","image":"PlayButton_image__2E1Aw"};